




import { InputPolicy, InputType, MaxBiteFilter } from "@/common/utils";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qInput",
})
export default class qInput extends Vue {
  @Prop ({
    required: true
  })
  value: string;

  @Prop({
    default: () => {
      return 'Text'
    }
  })
  mode: InputType;

  @Prop({
    default: () => {
      return 9999999
    }
  })
  max?: number;

  input = '';

  mounted() {
    this.update(this.value);
  }

  @Watch('value')
  onTextChanged(newText: string) {
    this.update(newText);
  }

  handleChange(event) {
    this.update(event.target.value);
  }

  update(newText: string) {
    const updated = this.replaceInput(newText);
    this.input = updated;
    this.$emit("input", updated);
  }

  replaceInput (input: string) {
    const checked = InputPolicy.check(input, this.mode);
    return MaxBiteFilter(checked, this.max);
  }
}
